import { useContext } from 'react';

import { ProductContext } from '@/context/product/ProductContext';

const useProductCtx = () => useContext(ProductContext);

export default useProductCtx;
